import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, Text } from '@calm-web/design-system';

export const Divider = styled.div`
	background: #c6c6c6;
	height: 1px;
	margin: 24px 0;
	width: 100%;
`;

export const HeadingContainer = styled.div`
	color: ${palette('gray7')};
	text-align: center;
`;

export const Heading = styled(Text).attrs({
	weight: FontWeights.Regular,
	el: 'h2',
	styleAs: 'h4',
})`
	margin-top: 0;
	margin-bottom: 8px;
`;

export const Subheading = styled.p`
	${fontWeight(FontWeights.Regular)};
	margin-bottom: 8px;
`;

export const OrderSummary = styled.div`
	color: ${palette('gray7')};
	margin: 24px 0 8px;
`;
